exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-gallery-tsx": () => import("./../../../src/pages/gallery.tsx" /* webpackChunkName: "component---src-pages-gallery-tsx" */),
  "component---src-pages-index-gatsby-tsx": () => import("./../../../src/pages/index-gatsby.tsx" /* webpackChunkName: "component---src-pages-index-gatsby-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-rirashi-tsx": () => import("./../../../src/pages/rirashi.tsx" /* webpackChunkName: "component---src-pages-rirashi-tsx" */)
}

